/*
 * @LastEditTime: 2020-09-22 14:15:05
 * @LastEditors: jinxiaojian
 */

let ua = navigator.userAgent.toLowerCase();  //获取用户端信息

//检测浏览器环境
function getBrowerInfo() {
  let info = {
    ie: /msie/.test(ua) && !/opera/.test(ua),  //匹配IE浏览器
    opera: /opera/.test(ua),  //匹配Opera浏览器
    safari: /version.*safari/.test(ua),  //匹配Safari浏览器
    chrome: /chrome/.test(ua),  //匹配Chrome浏览器
    firefox: /gecko/.test(ua) && !/webkit/.test(ua)  //匹配Firefox浏览器
  };
  return info
}

// 检测操作系统
function getSystemInfo() {
  let info = {
    win: /win/.test(ua),
    mac: /mac/.test(ua),
    linux: /x11/.test(ua) && /linux/.test(ua),
    unix: /x11/.test(ua) && !/linux/.test(ua),
  }
  return info
}
//是否移动端
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}


//获取屏幕缩放比例
function detectZoom() {
  let ratio = 0
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio = window.outerWidth / window.innerWidth;
  }
  return ratio;
};

//获取search上的单个参数
function getQuery(name: string) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
export { getQuery }

export { getBrowerInfo, getSystemInfo, isMobile, detectZoom }
